import { CoversTagKey } from '@/redux/slices/coverSlice'
import { identity } from 'lodash-es'
import { useCallback, useMemo, useState } from 'react'
import { RefreshControl, SectionList } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import CoverListFooter from './CoverListFooter'
import ParticipatedFormItem from './ParticipatedFormItem'

type ParticipatedFormListProps = {
  formIds: string[]
  isLoading: boolean
  hasNextPage: boolean
  isEmpty: boolean
  onLoadMore: () => void
  onRefresh: () => void
}

export default function ParticipatedFormList({
  formIds,
  isLoading,
  hasNextPage,
  isEmpty,
  onLoadMore,
  onRefresh,
}: ParticipatedFormListProps) {
  const insets = useSafeAreaInsets()
  const [refreshing, setRefreshing] = useState(false)

  const sections = useMemo(() => {
    if (formIds.length > 0) {
      return [{ title: '表单', data: formIds }]
    }
    return []
  }, [formIds])

  const renderItem = useCallback(
    ({ item: formId, index }: { item: string; index: number }) => {
      return <ParticipatedFormItem formId={formId} showBorder={index < formIds.length - 1} />
    },
    [formIds.length]
  )

  const handleRefresh = useCallback(() => {
    setRefreshing(true)
    onRefresh()
    setRefreshing(false)
  }, [onRefresh])

  const handleLoadMore = useCallback(() => {
    if (isLoading || isEmpty) return
    if (!hasNextPage) return

    onLoadMore()
  }, [isLoading, isEmpty, hasNextPage, onLoadMore])

  return (
    <SectionList
      sections={sections}
      renderItem={renderItem}
      stickySectionHeadersEnabled={false}
      keyExtractor={identity}
      className="bg-background-0"
      style={{ flex: 1 }}
      contentInsetAdjustmentBehavior="automatic"
      contentContainerStyle={{ paddingTop: 16, paddingBottom: insets.bottom + 16 }}
      refreshControl={<RefreshControl refreshing={refreshing} onRefresh={handleRefresh} />}
      onEndReached={handleLoadMore}
      onEndReachedThreshold={0.1}
      ListFooterComponent={() => (
        <CoverListFooter context={CoversTagKey.Participated} empty={isEmpty} loading={isLoading} />
      )}
    />
  )
}
